module.exports = __webpack_public_path__ + "static/media/SM-MT-7.85d6117d.mp3";